<script setup lang="ts">
defineProps<{
  open: boolean
}>()
</script>

<template>
  <div class="flex flex-col">
    <div
      class="overflow-hidden transition-height duration-500 ease-out w-full h-fit"
      :class="open ? '' : 'max-h-0'"
    >
      <slot></slot>
    </div>
  </div>
</template>
